import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import type { ProactiveDraftAware } from './types';

export default function isProactiveDraft(item: ProactiveDraftAware | undefined): boolean {
    if (!item || !item.IsDraft || item.DeferredSendTime) {
        return false;
    }
    if (isGlobalFeatureEnabled('mon-copilot-proactive-drafts-view-debug')) {
        return true;
    }
    if (!isGlobalFeatureEnabled('mon-copilot-proactive-drafts-view')) {
        return false;
    }
    return item.IsCopilotProactiveDraft === true;
}
